import { GA4_EVENT_NULL_SEARCH, GA4_EVENT_SEARCH_SUBMIT } from '@/data/constants/gtm';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { useSettings } from '@/data/Settings';
import type { GA4SearchType } from 'presentation/events/hooks/useTrackSearchSubmit/constants';
import { triggerGA4Event } from 'presentation/events/services/ga4EcommerceService';
import { useCallback } from 'react';

interface GA4EventParams {
	searchTerm: string;
	searchType: GA4SearchType;
	urlDestination: string;
	numberOfResults: number;
}

export const useTrackSearchSubmitGA4 = () => {
	const { settings } = useSettings();

	const sendGA4Event = useCallback(
		({ searchTerm, searchType, urlDestination, numberOfResults }: GA4EventParams) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4) return;

			const isNullSearch = numberOfResults === 0;

			const payload = {
				event: isNullSearch ? GA4_EVENT_NULL_SEARCH : GA4_EVENT_SEARCH_SUBMIT,
				event_category: isNullSearch ? 'Null search' : 'Search submit',
				search_term: searchTerm,
				search_type: isNullSearch ? 'Null search' : searchType,
				url_destination: urlDestination,
			};

			triggerGA4Event(payload);
		},
		[settings]
	);

	return { sendGA4Event };
};
